export const ITEM_SCOPE = 'item';
export const PAGE_SCOPE = 'page';
export const ITEM_GROUP_SCOPE = 'itemGroup';
